import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { removeDefaultParams } from 'src/common/utils'
import { IFilter } from 'src/components/filter/types/filter.types'
import { scanToEarnService } from 'src/services/scan-to-earn.service'
import { EConsumerScanStatus } from 'src/types'

export const initialtConsumerScansFilter = {
  query: '',
  status: [EConsumerScanStatus.PENDING],
  scanners: ['all'],
  product_type: ['all'],
  not_created: ['all'],
  challenges: ['all'],
}

export const useGetConsumerScans = (filter: IFilter) => {
  return useQuery(
    [QUERY_KEYS.CONSUMER_SCANS, filter],
    () =>
      scanToEarnService.getConsumerScans(
        removeDefaultParams(filter, { ...initialtConsumerScansFilter, status: ['all'] }),
      ),
    {
      keepPreviousData: true,
    },
  )
}
